export const selectLocationsStatus = (state) => state?.locations?.status;
export const selectLocationsError = (state) => state?.locations?.error;
export const selectLocationsList = (state) => state?.locations?.list;
